import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a2xtvyskxb: FaireBrandEntity = {
  token: "b_a2xtvyskxb",
  type: "brand",
  name: "K-Wonderland",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c0c9296b0ac3e9b8de2e72f3645dd5c89ea03d0ad4bbc53dfcf7ec3ff8a6e92.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f00fc40d070740f73e1a1efc31488ec1880d62855bf7489ee1b1c076259fd1a9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9c0c9296b0ac3e9b8de2e72f3645dd5c89ea03d0ad4bbc53dfcf7ec3ff8a6e92.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f00fc40d070740f73e1a1efc31488ec1880d62855bf7489ee1b1c076259fd1a9.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 135,
  isInsider: true,
  description:
    "Lucia's K-Wonderland\n\nWelcome to our store, where we focus on items that can bring a smile to your daily life. \nWe carefully select products inspired by everyday moments, aiming to create positive and joyous experiences. \nOur collection includes unique random toy capsules, props, socks, and handmade lifestyle products crafted in Korea. \nThese are the items we are especially excited to share with you.\n\nUSE Direct LINK: (You can get 5%OFF)\nhttps://faire.com/direct/kwonderland",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:12.508Z",
    importedBy: "entity-db-cli",
  },
};
